export enum DuplicateValuePolicy {
    Unspecified = 0,
    AllowDuplicatesWithWarning = 1,
    PreventDuplicates = 2
} 